export const occasionsData = [
// ----------------------- TITLE1 ---------------------
    {
      title: "House Warming",
      image: "https://www.partyone.in/suploads/2025/Feb/27/39341/1740648279image-29-1-1.webp",
      description: "Celebrate the joy of a new beginning with our thoughtfully designed house warming events.",
      details: [
        {
            title: "1BHK House Warming Flower Decoration",
            image: "https://www.partyone.in/suploads/2025/Feb/07/39309/1738910195image-246.webp",
            price: 8000,
            originalPrice: 10999
          },
          {
            title: "2 BHK Griha Pravesh Decoration",
            image: "https://www.partyone.in/suploads/2025/Feb/07/39311/1738919820image-245.webp",
            price: 12000,
            originalPrice: 16999
          },
          {
            
            title: "Authentic Marigold Banana Leaves Backdrop Decor",
            image: "https://www.partyone.in/suploads/2024/Dec/11/39142/1733899099image-85_Nero-AI_Photo.webp",
            price: 11000,
            originalPrice: 15000
          }, {
            title: "3BHK Griha Pravesh Marigold Flower Decoration",
            image: "https://www.partyone.in/suploads/2025/Feb/07/39314/1738925466image-12-Recovered.webp",
            price: 25000,
            originalPrice: 19999
          },
          {
            title: "Premium 1BHK Gruhapravesam Decoration",
            image: "https://www.partyone.in/suploads/2025/Feb/10/39325/1739191752image-22-1.webp",
            price: 14000,
            originalPrice: 22999
          },
          {
            title: "Best Housewarming Party Photography in Hyderabad",
            image: "https://www.partyone.in/suploads/2018/Jun/14/28896/1528972968hhhhhhhhhhhhhwww.webp",
            price: 15000,
            originalPrice: 24999
          },
          {
            title: "House Warming Party Invitations in Hyderabad",
            image: "https://www.partyone.in/suploads/2018/Jun/27/29631/1530097326h689.webp",
            price: 12,
            // originalPrice: 10999
          },
          {
            title: "House Warming Party Invitations in Hyderabad",
            image: "https://www.partyone.in/suploads/2018/Jun/27/29631/1530097326h6787.webp",
            price: 12,
            // originalPrice: 16999
          },
          {
            title: "2BHK Budget Friendly Griha Pravesh Flower Decor",
            image: "https://www.partyone.in/suploads/2025/Feb/07/39315/1738931753image-15_Nero-AI_Photo.webp",
            price: 4000,
            originalPrice: 6499

          },
          {
            
            title: "Griha Pravesh Pooja Backdrop Decoration",
            image: "https://www.partyone.in/suploads/2025/Feb/27/39340/1740647605image-27-1.webp",
            price: 11000,
            originalPrice: 16999
          },
          {
            title: "House Warming Entrance Chapra Decoration",
            image: "https://www.partyone.in/suploads/2025/Feb/27/39341/1740648279image-29-1-1.webp",
            price: 10000,
            originalPrice: 12500
          },
          {
            title: "Satyanarayana Swamy Vratham Griha Pravesh Flower D",
            image: "https://www.partyone.in/suploads/2025/Feb/27/39339/1740647096image-26-1.webp",
            price:12000,
            originalPrice:15000
          }
      ]
    },

// ----------------TITLE2---------------------
    {
      title: "Baby Shower",
      image: "https://www.partyone.in/suploads/2025/Mar/06/39361/1741254554b2109cc2-ff1d-44c6-9358-cd6480d3ef39.webp",
      description: "Welcome the little one with adorable baby shower themes.",
      details: [
        {
            title: "Artifical Flower Baby Shower Decoration",
            image: "https://www.partyone.in/suploads/2025/Mar/07/39365/1741325247image-14-1_Nero_AI_Image_Upscaler_Photo.webp",
            price: 8000,
            originalPrice: 10000
          },
          {
            title: "Baby Elephant Theme Decoration",
            image: "https://www.partyone.in/suploads/2025/Mar/06/39361/1741254554b2109cc2-ff1d-44c6-9358-cd6480d3ef39.webp",
            price: 12500,
            originalPrice: 14000
          },
          {
            title: "Baby Shower Delight Savvy Decoration",
            image: "https://www.partyone.in/suploads/2024/Sep/12/38826/1726120264IMG_E4732.webp",
            price: 5000,
            originalPrice: 6000
          }, {
            title: "Budget Friendly Natural Flower Seemantham Decor",
            image: "https://www.partyone.in/suploads/2025/Mar/14/39391/1741943299image-2-1_Nero_AI_Image_Upscaler_Photo.webp",
            price: 8500,
            originalPrice: 9500
          },
          {
            title: "Best Baby Shower Photo Shoot ",
            image: "https://www.partyone.in/suploads/2018/Jun/14/28899/1528973269bs.webp",
            price: 10000,
            // originalPrice: 16999
          },
          {
            title: "Baby Shower Invitation Card",
            image: "https://www.partyone.in/suploads/2018/Jun/27/29638/1530097827h87.webp",
            price: 12,
            // originalPrice: 6499
          }, 
          {
            title: "Baby Shower Invitation Card",
            image: "https://www.partyone.in/suploads/2018/Jun/27/29638/1530097827b56576.webp",
            price: 12,
            // originalPrice: 6499
          },
          {
            title: "Best Maternity Photography ",
            image: "https://www.partyone.in/suploads/2018/Jun/14/28898/1528973237mmmmmmmm.webp",
            price: 11000,
            // originalPrice: 16999
          },
          {
            title: "Elegant Gerbera And Rose Ring Flower Decor",
            image: "https://www.partyone.in/suploads/2024/Sep/27/39036/17274285931O6A5195.webp",
            price: 18000,
            originalPrice: 20000
          },
           {
            title: "Foot Print Baby Shower Balloon Decoration",
            image: "https://www.partyone.in/suploads/2025/Mar/07/39367/1741330554images1000x563.webp",
            price: 6000,
            originalPrice: 8000
          },
          {
            title: "Oh Baby Neon Light Baby Shower Decoration",
            image: "https://www.partyone.in/suploads/2024/Jul/02/38902/1719914462IMG_E8070.webp",
            price: 6500,
            originalPrice: 8500
          },
          {
            title: "Baby Shower Backdrop Flower Decoration",
            image: "https://www.partyone.in/suploads/2025/Mar/11/39388/1741677827image-17.webp",
            price: 10000,
            originalPrice: 14000
          }
      ]
    },

    // ------------- TITLE 3 ----------------
    {
      title: "Name Ceremony",
      image: "https://www.partyone.in/suploads/2025/Mar/10/39381/1741596811image-22-2.webp",
      description: "Mark the beautiful milestone of your child's name ceremony with a memorable celebration.",
      details: [
        {
            title: "Baby Girl Naming Ceremony Balloon Decor",
            image: "https://www.partyone.in/suploads/2025/Mar/08/39375/1741419110image-25-1.webp",
            price: 3000,
            originalPrice: 4000
          },
          {
            title: "Classy Cradle Ceremony Balloon Decoration",
            image: "https://www.partyone.in/suploads/2025/Mar/11/39387/1741673370polish-20211205-135844717-1000x1000_Nero_AI_Image_Upscaler_Photo.webp",
            price: 6500,
            originalPrice: 7500
          },
          {
            title: "Baby Boy Cradle Ceremony Balloon Decor",
            image: "https://www.partyone.in/suploads/2025/Mar/08/39376/1741419838image-24-1.webp",
            price: 2000,
            originalPrice: 3500
          }, {
            title: "Elegant Gerbera And Rose Ring Flower Decor",
            image: "https://www.partyone.in/suploads/2024/Sep/27/39036/17274285931O6A5195.webp",
            price: 20000,
            originalPrice: 22000
          },
          {
            title: "Naming Ceremony,Cradle Ceremony Photography",
            image: "https://www.partyone.in/suploads/2018/Jun/14/28897/1528973193nnnnnnnnnnnn.webp",
            price: 5000,
            originalPrice: 8000
          },
          {
            title: "Guess My Name Cradle Flower Decor",
            image: "https://www.partyone.in/suploads/2025/Mar/12/39394/1741757362424713899_738663994634575_4090638919894865616_n_1080-Recovered.webp",
            price: 14000,
            originalPrice: 15000
          }, {
            title: "Krishna Theme Naming Ceremony Balloon Decor",
            image: "https://www.partyone.in/suploads/2025/Mar/11/39386/1741672090White-and-Blue-Balloon-Decoration-for-Naming-Ceremony-scaled-1.webp",
            price: 8000,
            originalPrice: 10000
          },
          {
            title: "Name Reveal Pink Backdrop Ring Decor",
            image: "https://www.partyone.in/suploads/2025/Mar/10/39381/1741596811image-22-2.webp",
            price: 5000,
            originalPrice: 6000
          },
          {
            title: "Naming Ceremony Fresh Flower Decoration",
            image: "https://www.partyone.in/suploads/2025/Mar/12/39393/1741756787464909908_571694795318308_6156864140752420733_n_1080-1.webp",
            price: 12000,
            originalPrice: 14000
          }, {
            title: "Naming Ceremony Ring Balloon Decoration",
            image: "https://www.partyone.in/suploads/2025/Mar/10/39378/1741588771image-21-1.webp",
            price: 3500,
            originalPrice: 5000
          },
          {
            title: "Pooja Backdrop Cradle Ceremony Decoration",
            image: "https://www.partyone.in/suploads/2025/Mar/10/39380/1741593033468997907_1304605800539711_9040199010833550683_n_1080.webp",
            price: 12000,
            originalPrice: 16000
          },
          {
            title: "Guess My Name Naming Ceremony Flower Decor",
            image: "https://www.partyone.in/suploads/2024/Dec/21/39157/1734779053image-146.webp",
            price: 14000,
            originalPrice: 16000
          }
      ]
    },

    // ------------------ TITLE 4------------------
    {
      title: "Surprises",
      image: "https://www.partyone.in/suploads/2024/Jun/25/38856/1719320437IMG_E7333.webp",
      description: "We specialize in creating unforgettable surprise events.",
      details: [
        {
            title: "Car Boot Pop Up Surprise Decor",
            image: "https://www.partyone.in/suploads/2024/Oct/01/39013/1727785080WhatsApp-Image-2024-08-28-at-10.02.webp",
            price: 1700,
            originalPrice: 2000
          },
          {
            title: "Lovely Canopy and Love Box Surprise Decoration",
            image: "https://www.partyone.in/suploads/2024/Jun/25/38856/1719320437IMG_E7333.webp",
            price: 5500,
            originalPrice: 6500
          },
          {
            title: "Moonlit Moments Anniversary Surprise Decor",
            image: "https://www.partyone.in/suploads/2024/Aug/22/38969/17243062305-Upload.webp",
            price: 8000,
            originalPrice: 11000
          }, {
            title: "Red Hearts Marry Me Car Boot Decor",
            image: "https://www.partyone.in/suploads/2024/Oct/01/39019/1727785500Marry-Me-Car-Boot-Decoration-By-Loviesta-001-enhanced.webp",
            price: 1850,
            originalPrice: 2000
          },
          {
            title: "Best Guitar Surprise Party Planner",
            image: "https://www.partyone.in/suploads/2024/Sep/23/34321/1727082215Ziryab-Buist-Guitarist-in-Dubai-01%20(Custom)%20-%20Copy.webp",
            price: 4000,
            // originalPrice: 
          },
          {
            title: "Customized Personal Radio Show ",
            image: "https://www.partyone.in/suploads/2025/Mar/21/39424/1742549696portait-of-two-happy-radio-hosts-young-man-and-wo-2025-03-14-01-53-28-utc.webp",
            price: 1800,
            originalPrice: 2000
          }, {
            title: "Better Together Valentines Cabana Decoration",
            image: "https://www.partyone.in/suploads/2025/Jan/27/39273/1737979645WhatsApp-Image-2025-01-22-at-42136-PM-1.webp",
            price: 11000,
            originalPrice: 13000
          },
          {
            title: "Photo Balloon Decor with Rose Petal Path",
            image: "https://www.partyone.in/suploads/2025/Jan/27/39272/1737979336image-238.webp",
            price: 10000,
            originalPrice: 11000
          },
          {
            title: "Dreamy Marry Me Terrace Proposal Decoration",
            image: "https://www.partyone.in/suploads/2025/Jan/27/39271/1737979065image-233-1.webp",
            price: 11000,
            originalPrice: 13000
          }, {
            title: "Car Boot Joy Party Decor",
            image: "https://www.partyone.in/suploads/2024/Oct/01/39012/1727785203car%20boot.webp",
            price: 1500,
            originalPrice: 1700
          },
          {
            title: "Valentines Day Canopy Terrace Decoration",
            image: "https://www.partyone.in/suploads/2025/Jan/28/39275/1738064251image-240.webp",
            price: 4000,
            originalPrice: 5000
          },
          {
            title: "Surprise for Husband Car Boot Decor",
            image: "https://www.partyone.in/suploads/2024/Oct/01/39018/1727782949Anniversary-Car-Boot-Decor-450x450.webp",
            price: 2000,
            originalPrice: 2300
          }
      ]
    }
  ];
  